<div class="container about">
  <hr />

  <p>
    <strong>O QUE É?</strong>
  </p>

  <p>
    O <strong>Simulador de Custo-Aluno Qualidade (SimCAQ)</strong> é um sistema gratuito e disponível na internet (simcaq.ufg.br) 
    que estima o custo da oferta de ensino em condições de qualidade nas escolas públicas de educação básica, ou seja, o Custo-Aluno Qualidade (CAQ).
  </p>

  <p>
    É uma ferramenta de planejamento educacional com ênfase no aspecto orçamentário que realiza o diagnóstico dos contextos educacionais e permite 
    a inserção e a edição de inúmeros parâmetros de condições de oferta para simular o orçamento necessário.
  </p>

  <p>
    <strong>Objetivos:</strong>
  </p>

  <ul>
    <li>
      <p>
        Calcular o CAQ por meio de conjunto de parâmetros relativos aos insumos e recursos monetários, denominados como Padrão de Qualidade de Referência (PQR), 
        somando esforços para tornar possível a implementação do CAQ estabelecido no Art. 207 da Constituição Federal e no Plano Nacional de Educação (PNE 2014-2024)- Lei n° 13.005/2014.
      </p>
    </li>

    <li>
      <p>
        Subsidiar a elaboração, adequação e monitoramento dos Planos Estaduais e Municipais de Educação, visando a articulação das metas educacionais locais com as metas do Plano Nacional de Educação 
        e a previsão do montante de recursos financeiros necessário para a oferta da educação básica em condições de qualidade.
      </p>
    </li>

    <li>
      <p>
        Fomentar pesquisas e publicações sobre financiamento da educação, custos educacionais e oferta da educação básica em condições de qualidade.
      </p>
    </li>

    <li>
      <p>
        Promover o debate entre pesquisadores(as), gestores(as) das redes de ensino, governos, profissionais da educação e sociedade civil sobre desafios para o financiamento da educação básica.
      </p>
    </li>
  </ul>

  <hr />

  <p>
    <strong>PÚBLICO-ALVO</strong>
  </p>

  <ul>
    <li>
      Gestores das secretarias municipais, estaduais e Ministério da Educação;
    </li>

    <li>
      Gestores dos órgãos de planejamento e finanças das três esferas de
      governo;
    </li>

    <li>Agentes do poder legislativo;</li>

    <li>Agentes do Ministério Público e do Tribunal de Contas;</li>

    <li>Agentes dos conselhos municipais, estaduais e nacional de educação;</li>

    <li>Sindicatos de trabalhadores e profissionais da educação;</li>

    <li>Comunidade escolar (alunos(as), pais/mães/responsáveis e profissionais da educação);</li>

    <li>Movimentos sociais;</li>

    <li>Organizações da sociedade civil;</li>

    <li>
      Comunidade acadêmica;
    </li>

    <li>Imprensa.</li>
  </ul>

  <hr />

  <p>
    <strong>REALIZAÇÃO</strong>
  </p>

  <p>
    O Simulador é resultado de pesquisas do Laboratório de Dados Educacionais (LDE) - grupo de pesquisa, interdisciplinar e interinstitucional, 
    que reúne professores(as), técnicos(as) e discentes do Departamento de Planejamento e Administração Escolar da Universidade Federal do Paraná (DEPLAE/UFPR) 
    e da Faculdade de Administração, Ciências Contábeis e Ciências Econômicas da Universidade Federal de Goiás (FACE/UFG) e da Faculdade de Filosofia, Ciências e 
    Letras de Ribeirão Preto da Universidade de São Paulo (FFCLRP-USP).
  </p>

  <p>
    A parte computacional é desenvolvida pela Fábrica de Software (FS) do Instituto de Informática da Universidade Federal de Goiás.
  </p>

  <p>
    Dessa forma, o projeto reúne conhecimentos produzidos nestas universidades nas áreas da Educação, Computação e Administração Pública.
  </p>

  <p>
    Atualmente conta com financiamento por meio de um Termo de Execução Descentralizada (TED) firmado entre Universidade Federal de Goiás 
    e Secretaria de Educação Básica do Ministério da Educação (SEB/MEC) com vistas ao seu aprimoramento.
  </p>

  <p>
    O projeto foi financiado no período de outubro/2015 a outubro/2019 por meio de um (TED) firmado entre a UFPR e a Secretaria de Articulação 
    com os Sistemas de Ensino do Ministério da Educação (SASE/MEC).
  </p>

  <p>
    É importante frisar que
    <strong>
      entre as Universidades e o MEC e que os conteúdos do SimCAQ são de autoria e responsabilidade da equipe do projeto
    </strong>.
  </p>

  <hr>

  <p>
    <strong>Instituições e departamentos envolvidos:</strong>
  </p>

  <p>
    UNIVERSIDADE FEDERAL DE GOIÁS <br>
    Faculdade de Administração, Ciências Contábeis e Ciências Econômicas (FACE) <br>
    Fábrica de Software do Instituto de Informática (FS/INF) <br>
    Laboratório Multiusuário de Computação de Alto Desempenho (LaMCAD).
  </p>

  <p>
    UNIVERSIDADE FEDERAL DO PARANÁ <br>
    Setor de Educação <br>
    Departamento de Planejamento e Administração Escolar (DEPLAE)
  </p>

  <p>
    UNIVERSIDADE DE SÃO PAULO <br>
    Faculdade de Filosofia, Ciências e Letras de Ribeirão Preto (FFCLRP)
  </p>

  <p>
    <u>Financiamento:</u><br>
    Ministério da Educação
  </p>

  <p>
    <u>Apoio administrativo:</u><br>
    Fundação de Apoio à Pesquisa (Funape) da UFG
  </p>

  <hr />

  <p>
    <strong>Trajetória</strong>
  </p>

  <p>
    A ideia inicial do SimCAQ surgiu em 2008 motivada pelas evidências de subfinanciamento em parte significativa das escolas públicas do Brasil, 
    evidenciados pela precariedade da infraestrutura física dos prédios, falta de condições materiais para o trabalho pedagógico e baixos salários. 
    Essa realidade já havia sido revelada em inúmeras pesquisas que, desde o final da década de 1980, 
    indicava o Custo-Aluno Qualidade (CAQ) como parâmetro adequado para o financiamento da educação básica no país.
  </p>

  <p>
    Nesse contexto, o trabalho de Denise Carreira e José Marcelino de Rezende Pinto (2007), “Custo aluno-qualidade inicial: rumo à educação pública de qualidade no Brasil”, 
    foi o ponto de partida para a elaboração do modelo teórico que deu origem ao SimCAQ.  
    Esta publicação aconteceu no âmbito dos trabalhos de incidência política da 
    <strong>Campanha Nacional Pelo Direito à Educação</strong> que culminou na inserção do CAQi/CAQ como uma das estratégias da meta 20 do PNE 2014-2024.
  </p>

  <p>A versão atual do SimCAQ foi uma construção realizada em etapas:</p>

  <p>
    <strong>1ª ETAPA</strong><br>
    Um projeto de tese de doutorado foi apresentado em 2008 ao programa de Pós-Graduação em Administração da Faculdade de Economia e Administração da Universidade de São Paulo (FEA/USP) 
    na linha de pesquisa 'Métodos Quantitativos e Informática'. A tese foi elaborada de 2010 a 2012 por <strong>Thiago Alves</strong>, sob orientação de <strong>Adriana Backx Noronha Viana</strong> e <strong>José Marcelino de Rezende Pinto</strong>. 
    Nesse trabalho foi desenvolvido o modelo conceitual, além das primeiras demonstrações de cálculos e funcionalidades do SimCAQ (ALVES, 2012). A tese foi premiada como a melhor tese da USP defendida em 2012 na área das Ciências Sociais aplicada.
  </p>
  <p>
    O desenvolvimento do simulador foi iniciado em 2011 com financiamento do Observatório da Educação/CAPES em projeto coordenado 
    pela Profa. Cláudia Souza Passador (FEARP/USP). Naquele momento, com os recursos disponíveis, 
    só foi possível iniciar o desenvolvimento de um protótipo baseado em planilhas eletrônicas. O projeto foi interrompido por dois anos a partir de julho/2012.
  </p>

  <p>
    <strong>2ª ETAPA</strong><br>
    Em 2014, após a sanção do PNE 2014-2024, uma parceria entre a SASE/MEC e a Faculdade de Administração, Contabilidade e Economia da Universidade Federal de Goiás (FACE/UFG) 
    coordenada por Thiago Alves tornou possível o desenvolvimento de um 
    protótipo com várias funcionalidades (versão desktop). Aquele protótipo demonstrou o potencial do simulador como ferramenta de planejamento. 
    A decisão da SASE/MEC de financiar uma versão com estrutura tecnológica para disponibilização na internet para a sociedade foi tomada em 2015 
    depois de repetidas manifestações de apoio de entidades que compunham o Fórum Nacional de Educação à época.
  </p>

  <p>
    <strong>3ª ETAPA</strong><br>
    A primeira versão disponibilizada para a sociedade foi desenvolvida de 2016 a 2019 com recursos públicos oriundos do orçamento do Ministério da Educação. 
    Foi resultado de esforços de uma equipe composta por mais de vinte pessoas coordenada por 
    <strong>Adriana Dragone Silveira (Deplae/UFPR)</strong>,
    <strong>Gabriela Schneider (Deplae/UFPR)</strong>,
    <strong>Marcos Didonet Del Fabro (C3SL/UFPR)</strong> e
    <strong>Thiago Alves (FACE/UFG)</strong>. Também contou com a importante
    parceria do
    <strong>Prof. José Marcelino de Rezende Pinto (FFCLRP/USP)</strong>. A versão disponibilizada pela plataforma avançou em muito em termos de concepção, funcionalidades, 
    design e tecnologia em relação às etapas anteriores. É fruto de intenso trabalho coletivo multidisciplinar de pesquisadores(as) e profissionais que desenvolveram 
    coletivamente, no ambiente fecundo de conhecimentos das universidades federais, uma ferramenta de planejamento que pode contribuir para a mudança de concepção do 
    financiamento da educação básica brasileira como forma de garantir o direito à educação pública, gratuita e de qualidade para todos/as crianças, jovens e adultos do Brasil. 
    Essa etapa do projeto foi realizada em parceria com o Centro de Computação Científica e Software Livre (C3SL) da UFPR para o desenvolvimento computacional. 
  </p>

  <p>
    <strong>4ª ETAPA</strong><br>
    A partir de 2023, os cálculos do SimCAQ passaram a ser realizados no nível das escolas. Esta alteração aumentou significativamente o nível de precisão dos cálculos. 
    Houve um ganho em termos de validade e confiabilidade do conceito de CAQ. Essa alteração foi motivada pelo resultado de um projeto de pesquisa realizado em parceria 
    com a rede municipal de Vitória-ES de 2021 a 2023.
  </p>
  <p>
    A Fábrica de Software (FS) do Instituto de Informática da UFG assumiu o desenvolvimento computacional do SimCAQ em 2022.
  </p>
  <p>
    Esta nova parceria foi fundamental para a adaptação do SimCAQ ao novo formato de disponibilização dos microdados do Censo Escolar pelo Inep a partir de 2022. 
    A alteração do Inep tornou necessária uma reestruturação completa do simulador.  O trabalho na Fábrica de Software internalizou todos os processos do simulador na UFG.  
    Como consequência, o tempo das simulações que utilizam grandes volumes de dados foi reduzido significativamente. Além disso, 
    novos processos de desenvolvimento foram adotados com vistas a tornar mais ágeis o desenvolvimento, os testes e a manutenção do sistema. 
    Desse modo, o sistema teve significativo avanço em termos de velocidade, qualidade dos processos, usabilidade, segurança e sustentabilidade.
  </p>

  <hr>

  <p>
    <strong>REFERÊNCIAS</strong>
  </p>

  <p class="reference">
    ALVES, T.; SCHNEIDER, G.; SILVEIRA, A. D. <strong>Financiamento das escolas públicas em condições de qualidade: questionamento dos fatores de ponderação do Fundeb na perspectiva do CAQ</strong>. REVISTA COCAR (ONLINE), v. 27, p. 1-18, 2024.
  </p>

  <p class="reference">
    ALVES, T.; SILVEIRA, A. D.; SCHNEIDER, G.; DEL FABRO, M. D. <strong>Financiamento da escola pública de educação básica: a proposta do Simulador de Custo-Aluno Qualidade</strong>. Educação & Sociedade, v. 40, p. 1-40, 2019. 
    <a href="https://www.scielo.br/scielo.php?script=sci_arttext&pid=S0101-73302019000100211">https://www.scielo.br/scielo.php?script=sci_arttext&pid=S0101-73302019000100211</a>
  </p>

  <p>
    ALVES, T. <strong>Desenvolvimento de um modelo de previsão de custos para planejamento de sistemas públicos de educação básica em condições de qualidade: uma aplicação a municípios de Goiás</strong>. 353f. 
    Tese (Doutorado em Administração) - Faculdade de Economia, Administração e Contabilidade, Universidade de São Paulo, São Paulo, 2012.
  </p>

  <p>
    CARREIRA, D.; PINTO, J.M.R. <strong>Custo aluno-qualidade inicial: rumo à educação pública de qualidade no Brasil</strong>. Campanha Nacional pelo Direito à Educação, 2007.
  </p>

  <p>
    SILVEIRA, A. D.; SCHNEIDER, G.; ALVES, T. <strong>Simulador de Custo-Aluno Qualidade (SimCAQ): Trajetória e Potencialidades.</strong> 
    In: Marcelo Lopes de Souza; Fabiana de Assis Alves; Gustavo Henrique Moraes. (Org.). Custo Aluno Qualidade (CAQ): contribuições conceituais e metodológicas. 
    1ed.Brasília: INEP/MEC, 2021, v. 1, p. 147-180. 
    <a href="https://download.inep.gov.br/publicacoes/diversas/financiamento_da_educacao/custo_aluno_qualidade_caq.pdf">
      https://download.inep.gov.br/publicacoes/diversas/financiamento_da_educacao/custo_aluno_qualidade_caq.pdf
    </a>
  </p>

  <p>
    SILVEIRA, A. D.; SCHNEIDER, G.; ALVES, T. <strong>Aspectos metodológicos do cálculo do CAQ utilizando o Simulador de Custo-Aluno Qualidade (SIMCAQ).</strong> 
    In: Marcelo Lopes de Souza; Fabiana de Assis Alves; Gustavo Henrique Moraes. (Org.). 
    Custo Aluno Qualidade (CAQ): contribuições conceituais e metodológicas. 1ed.Brasília: INEP/MEC, 2021, v. 1, p. 275-314. 
    <a href="https://download.inep.gov.br/publicacoes/diversas/financiamento_da_educacao/custo_aluno_qualidade_caq.pdf">
      https://download.inep.gov.br/publicacoes/diversas/financiamento_da_educacao/custo_aluno_qualidade_caq.pdf
    </a>
  </p>
</div>
